import React from "react";

export const WordIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="16"
    viewBox="0 0 12 16"
    fill="none"
    data-testid="file-icon-word"
    {...props}
  >
    <path
      d="M1.5 14V2C1.5 1.725 1.725 1.5 2 1.5H7V4C7 4.55312 7.44688 5 8 5H10.5V14C10.5 14.275 10.275 14.5 10 14.5H2C1.725 14.5 1.5 14.275 1.5 14ZM2 0C0.896875 0 0 0.896875 0 2V14C0 15.1031 0.896875 16 2 16H10C11.1031 16 12 15.1031 12 14V4.82812C12 4.29688 11.7906 3.7875 11.4156 3.4125L8.58438 0.584375C8.20938 0.209375 7.70312 0 7.17188 0H2ZM3.71875 7.53438C3.6 7.1375 3.18125 6.9125 2.78437 7.03125C2.3875 7.15 2.1625 7.56875 2.28125 7.96562L3.78125 12.9656C3.875 13.2844 4.16875 13.5 4.5 13.5C4.83125 13.5 5.12187 13.2812 5.21875 12.9656L6 10.3594L6.78125 12.9656C6.875 13.2844 7.16875 13.5 7.5 13.5C7.83125 13.5 8.12187 13.2812 8.21875 12.9656L9.71875 7.96562C9.8375 7.56875 9.6125 7.15 9.21562 7.03125C8.81875 6.9125 8.4 7.1375 8.28125 7.53438L7.5 10.1406L6.71875 7.53438C6.625 7.21563 6.33125 7 6 7C5.66875 7 5.37813 7.21875 5.28125 7.53438L4.5 10.1406L3.71875 7.53438Z"
      fill="#3B82F6"
    />
  </svg>
);
